import * as React from "react";

function BadgeCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M240.1 336.1c-8.5 10.2-23.7 10.2-33.1 0l-56-56c-9.3-8.5-9.3-23.7 0-33.1 9.4-9.3 24.6-9.3 33.1 0l39.9 39.1 95-95.1c9.4-9.3 24.6-9.3 33.1 0 10.2 9.4 10.2 24.6 0 33.1l-112 112zm104-292.69c32.9-4.31 67.5 6.18 92.9 31.57 25.4 25.42 35.9 59.12 31.6 92.92 25.5 20.3 43.4 52.2 43.4 88.1 0 35.9-17.9 67.8-43.4 88.1 4.3 32.9-6.2 67.5-31.6 92.9-25.4 25.4-60 35.9-92.9 31.6-20.3 25.5-52.2 43.4-88.1 43.4-35.9 0-67.8-17.9-88.1-43.4-33.8 4.3-67.5-6.2-92.92-31.6-25.38-25.4-35.88-60-31.57-92.9C17.04 323.8 0 291.9 0 256c0-35.9 17.04-67.8 43.42-88.1-4.32-33.8 6.18-67.5 31.56-92.92C100.4 49.6 134.1 39.1 167.9 43.41 188.2 17.04 220.1 0 256 0c35.9 0 67.8 17.04 88.1 43.41zm-154 55.66L172 93.25c-21.6-6.65-46.9-1.38-63.1 15.65-17.03 16.2-22.3 41.5-15.65 63.1l5.82 18.1-17.52 10.2C61.54 210.9 48 231.9 48 256s13.54 45.1 33.55 55.7l17.52 9.3-5.82 18.1c-6.65 22.5-1.38 46.9 15.65 64 16.2 17 41.5 22.3 63.1 15.6l18.1-5.8 10.2 17.6c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5l9.3-17.6 18.1 5.9c22.5 6.6 46.9 1.3 64-15.7 17-17.1 22.3-41.5 15.6-64l-5.8-18.1 17.6-9.3c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7l-17.6-10.2 5.8-18.1c6.7-21.6 1.4-46.9-15.6-63.1-17.1-17.03-41.5-22.3-64-15.65L321 99.07l-9.3-17.52C301.1 61.54 280.1 48 256 48s-45.1 13.54-55.7 33.55l-10.2 17.52z"
  }));
}

const ForwardRef = React.forwardRef(BadgeCheckIcon);
export default ForwardRef;